import React, { useEffect, useState } from 'react';
import { TrendingUpIcon, UsersIcon, DollarSignIcon, ArrowRightIcon, PlayCircleIcon } from 'lucide-react';
import { AnimatedMetric } from '../ui/AnimatedMetric';
export function HomeSocialProof() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const metrics = [{
    icon: UsersIcon,
    value: 3000,
    suffix: '+',
    label: 'Reps Hired'
  }, {
    icon: DollarSignIcon,
    value: 150,
    suffix: 'M+',
    prefix: '$',
    label: 'Production from Hired Reps'
  }, {
    icon: TrendingUpIcon,
    value: 45,
    suffix: '%',
    label: 'Better Retention (Weeks 1–8)'
  }];
  const testimonials = [{
    quote: 'They helped us tighten our back-end so we could grow based on real, reliable, predictable systems instead of hopes, dreams, and shoestrings. We stopped second-guessing our training and started keeping the right people.',
    author: 'Russell, VP of Sales, Shared Solar Advisors'
  }, {
    quote: 'It took the headache out of recruiting and gave me my time back. In our first month, we brought on eight new reps. Three months later, six of them are still here and producing. We are now the top office in the company.',
    author: 'Nolan, Market Owner, Elite Windows'
  }, {
    quote: "They helped us hire nearly 100 new sales reps in one season, and many are now among our top performers. I have confidence knowing I don't just have a recruiting vendor. I have a true business partner.",
    author: 'Alden, Executive, Premier Roofing'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  return <section className="section-padding bg-white" data-id="element-442">
      <div className="container-custom" data-id="element-443">
        <div className="max-w-5xl mx-auto" data-id="element-444">
          <div className="text-center mb-10 md:mb-12" data-id="element-445">
            <h2 className="mb-3 md:mb-4" data-id="element-446">We Let The Numbers Talk</h2>
            <p className="text-body-large" data-id="element-447">
              We don't guess. We track everything. Here is what we have done for
              D2D teams like yours.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-8 md:mb-12" data-id="element-448">
            {metrics.map((metric, index) => {
            const Icon = metric.icon;
            return <div key={index} className="bg-gray-50 rounded p-5 md:p-6 lg:p-8 shadow-lg border-2 border-gray-200 text-center" data-id="element-449">
                  <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-slate/10 rounded flex items-center justify-center mx-auto mb-3 md:mb-4" data-id="element-450">
                    <Icon className="h-5 w-5 md:h-6 md:w-6 lg:h-7 lg:w-7 text-slate" data-id="element-451" />
                  </div>
                  <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-navy mb-1 md:mb-2" data-id="element-452">
                    <AnimatedMetric value={metric.value} prefix={metric.prefix} suffix={metric.suffix} duration={2000} data-id="element-453" />
                  </div>
                  <p className="font-medium text-sm" data-id="element-454">{metric.label}</p>
                </div>;
          })}
          </div>

          <div className="bg-white rounded p-5 md:p-6 lg:p-8 shadow-lg border-2 border-slate mb-6 md:mb-8 relative overflow-hidden" data-id="element-455">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6" data-id="element-456">
              <div className="flex-1 relative" style={{
              minHeight: '120px'
            }} data-id="element-457">
                {testimonials.map((testimonial, index) => <div key={index} className="absolute inset-0 transition-opacity duration-700" style={{
                opacity: currentTestimonial === index ? 1 : 0,
                pointerEvents: currentTestimonial === index ? 'auto' : 'none'
              }} data-id="element-458">
                    <p className="text-body-large italic mb-2" data-id="element-459">
                      "{testimonial.quote}"
                    </p>
                    <p className="text-sm font-semibold" data-id="element-460">
                      – {testimonial.author}
                    </p>
                  </div>)}
              </div>
              <a href="/case-studies" className="flex items-center text-slate font-bold hover:text-slate-dark transition-colors whitespace-nowrap text-sm flex-shrink-0" data-id="element-461">
                View All Case Studies{' '}
                <ArrowRightIcon className="ml-2 h-4 w-4 md:h-5 md:w-5" data-id="element-462" />
              </a>
            </div>

            {/* Dot indicators */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-463">
              {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentTestimonial(index)} className={`w-2 h-2 rounded-full transition-all ${currentTestimonial === index ? 'bg-slate w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`View testimonial ${index + 1}`} data-id="element-464" />)}
            </div>
          </div>

          <div className="text-center" data-id="element-465">
            <a href="/case-studies#testimonials" className="inline-flex items-center justify-center bg-navy hover:bg-navy-light text-white font-bold px-6 md:px-8 py-3 md:py-4 rounded transition-colors shadow-lg text-sm" data-id="element-466">
              <PlayCircleIcon className="mr-2 h-4 w-4 md:h-5 md:w-5" data-id="element-467" />
              Watch Video Testimonials
            </a>
          </div>
        </div>
      </div>
    </section>;
}